<template>
  <!-- 食事マスタ登録画面 -->
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-container>
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar class="headline" color="primary" dark>食事マスタ設定</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="4">
                <ryou-input label="食事区分名" v-model="model.meal_name" :value="model.meal_name" :rules="inputRulesTen">
                </ryou-input>
              </v-col>
              <v-col cols="4">
                <ryou-input label="食事単価" v-model="model.meal_unit_price" :value="model.meal_unit_price"
                  prepend-icon="mdi-currency-cny" :prependIcon="'mdi-currency-cny'" :rules="inputRulesFive">
                </ryou-input>
              </v-col>
              <v-col cols="4">
                <ryou-input label="会社負担額" v-model="model.meal_company_amount" :value="model.meal_company_amount"
                  prepend-icon="mdi-currency-cny" :rules="inputRulesFive">
                </ryou-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="radioTitle">
                <ryou-radio v-model="model.tax_class" :value="model.tax_class" :items="radioItems" :rules="dateRules"
                  :label="'税区分'">
                </ryou-radio>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'" :handlerClick="handleOk"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouRadio from "@/components/formInput/RyouRadio.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

  export default {
    name: "MasterMealInsertDialog",
    components: {
      RyouInput,
      RyouRadio,
      RyouBlackBtn,
    },
    mounted() {
      this.inputRulesTen.push(this.GlobalRules.required);
      this.inputRulesTen.push(this.GlobalRules.counter_10);

      this.inputRulesFive.push(this.GlobalRules.required);
      this.inputRulesFive.push(this.GlobalRules.counter_5);
      this.inputRulesFive.push(this.GlobalRules.currency);

      this.dateRules.push(this.GlobalRules.required);
    },
    props: {
      url: {
        type: Object,
        required: true,
        default: () => { },
      },
    },
    data: () => ({
      dialog: false,
      buildGroupId: "",
      mealCostUpdateFlg: true,
      valid: true,
      inputRulesTen: [],
      inputRulesFive: [],
      dateRules: [],
      radioItems: [
        {
          value: "1",
          label: "消費税率",
        },
        {
          value: "2",
          label: "軽減税率",
        },
        {
          value:"3",
          label:"税込み",
        },
      ],
      model: {
        build_group_id: "",
        meal_class: "",
        meal_name: "",
        meal_unit_price: "",
        tax_class: "",
        meal_company_amount: "",
      },
    }),
    methods: {
      add(value) {
        this.buildGroupId = value;
        this.mealCostUpdateFlg = false;
        this.open();
        this.title = "食事料金マスタ新規";
      },
      edit(record) {
        this.open();
        this.title = "食事料金マスタ編集";
        this.mealCostUpdateFlg = true;
        setTimeout(() => {
          this.model = Object.assign({}, record);
        }, 10);
      },
      handleOk() {
        var valid = this.$refs.p1DialogForm.validate();
        if (valid) {
          var that = this;
          if (this.mealCostUpdateFlg) {
            let params = {
              user_id: this.$store.getters.getUserId,
              build_group_id: this.model.build_group_id,
              meal_class: this.model.meal_class,
              meal_name: this.model.meal_name,
              meal_unit_price: this.model.meal_unit_price,
              tax_class: this.model.tax_class,
              meal_company_amount: this.model.meal_company_amount,
            };
              this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then((resp) => {
              if (resp.success) {
                that.$emit("ok");
              }
              that.close();
            });
          } else {
            let insertParams = {
              user_id: this.$store.getters.getUserId,
              build_group_id: this.buildGroupId,
              meal_name: this.model.meal_name,
              meal_unit_price: this.model.meal_unit_price,
              tax_class: this.model.tax_class,
              meal_company_amount: this.model.meal_company_amount,
            };
              this.postRequest(this.url.add, insertParams, this.$store.getters.getUserToken).then((resp) => {
              if (resp.success) {
                that.$emit("ok");
              }
              that.close();
            });
          }
        }
      },
      handleCancel() {
        this.close();
      },
      close() {
        this.dialog = false;
      },
      open() {
        this.dialog = true;
        if (this.$refs.p1DialogForm) {
          this.$refs.p1DialogForm.reset();
          this.$refs.p1DialogForm.resetValidation();
        }
      },
    },
  };
</script>

<style scoped>
  .InsertTitle {
    padding: 0px 0px 25px !important;
  }

  .radioTitle {
    padding-top: 0px;
  }
</style>